module.exports = __webpack_public_path__ + "static/img/guoping_yang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/guoping_yang.jpg
// module id = paK7
// module chunks = 0